<button
  [id]="btnID"
  [ngClass]="btnClass"
  (click)="resend()"
  [disabled]="btnResendDisabled()">
  {{ label }}
</button>
@if (btnResendDisabled()) {
  <p class="small text-muted mt-2">
    {{ requestMessage }}
    <span class="fw-bold">{{ timeoutTimer() }}</span>
  </p>
}
